import { shareAsync } from './share-async';

export type GameStatus = 'active' | 'hidden' | 'archived';
export type GameTheme = { primary?: string; accent?: string; heroBackground?: string };
export type GameConfig = {
  key: string;
  name: string;
  icon: string;
  domain: string;
  status: GameStatus;
  theme: GameTheme;
  settings: Record<string, unknown>;
};

export function normalizeGameConfig(value: Partial<GameConfig>): GameConfig {
  const key = String(value.key || value.domain || '').trim().toLowerCase();
  return {
    key,
    name: String(value.name || '').trim(),
    icon: String(value.icon || '').trim(),
    domain: String(value.domain || key).trim().toLowerCase(),
    status: ['active','hidden','archived'].includes(String(value.status)) ? value.status as GameStatus : 'active',
    theme: value.theme && typeof value.theme === 'object' ? value.theme : {},
    settings: value.settings && typeof value.settings === 'object' ? value.settings : {},
  };
}

const gamesInflight = new Map<string, Promise<GameConfig[]>>();

export async function fetchGames(includeHidden = false) {
  const key = includeHidden ? 'all' : 'public';
  return shareAsync(gamesInflight, key, async () => {
    const response = await fetch(`/api/games${includeHidden ? '?all=1' : ''}`, { cache: 'no-store' });
    if (!response.ok) throw new Error('游戏注册中心读取失败');
    return (await response.json() as { games: GameConfig[] }).games.map(normalizeGameConfig);
  });
}
